import { useEffect, useState } from 'react';
import * as http from '../api/http';
import { Event, IQnaSession } from '../types';
import { Session } from '@bizzabo/entities';

const useQnaSession = (event: Event, session: Session): { qnaEntity: IQnaSession } => {
    const [qnaEntity, setQnaEntity] = useState<IQnaSession>();

    useEffect(() => {
        const init = async () => {
            const qnaRes = await http.getBySession({
                eventId: event.id,
                sessionId: session.id,
            });

            setQnaEntity(qnaRes as IQnaSession);
        };

        const isQnaEnabled = session?.qna?.enable;
        if (!!event && !!session && isQnaEnabled) {
            init();
        }
    }, [event?.id, session?.id]);

    return { qnaEntity };
};

export default useQnaSession;
